import { CLEAR_SELECTION, SET_SELECTED_CARDS, SET_SHOW_CHECKBOXES, TOGGLE_CARD } from '../types'

export const setShowCheckboxes = (show) => ({
  type: SET_SHOW_CHECKBOXES,
  payload: show,
});

export const setSelectedCards = (cards) => ({
  type: SET_SELECTED_CARDS,
  payload: cards,
});

export const clearSelection = () => ({
  type: CLEAR_SELECTION,
});

export const toggleCard = (cardId) => ({
  type: TOGGLE_CARD,
  payload: cardId,
});
